import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  /**
   * Mobile breakpoint max width (pixels).
   * Mirrors Tailwind's `md` breakpoint start (>=768 becomes tablet/desktop).
   */
  private readonly MOBILE_MAX_WIDTH = 767;

  /**
   * Determines if current viewport is mobile-sized.
   * - SSR safe (returns false when window unavailable)
   * - Uses matchMedia for dynamic/responsive accuracy
   */
  isMobile(): boolean {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${this.MOBILE_MAX_WIDTH}px)`).matches;
  }

  isObjectEmpty<T extends object>(obj: T): boolean {
    return !!obj && Object.keys(obj).length === 0;
  }

  /**
   * Scrolls viewport to top. Safe for SSR (no-op if window unavailable).
   * @param behavior 'auto' | 'smooth' (default 'smooth')
   * @param topOffset override target top position (default 0)
   */
  scrollToTop(behavior: ScrollBehavior = 'smooth', topOffset = 0): void {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.scrollTo({
        top: topOffset,
        behavior,
      });
    } catch {
      document.documentElement.scrollTop = topOffset;
      document.body.scrollTop = topOffset;
    }
  }
}
